export default __webpack_public_path__ + "static/landfill-video-7df96569ace640acb0219bca67c68fbe.mp4";